import EditCustomDomainListModal from "./EditCustomDomainListModal";

export default EditCustomDomainListModal;
